/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable no-labels */
/* eslint-disable no-console */
import { AnimatePresence, motion } from 'framer-motion';
import { cloneDeep } from 'lodash';
import { Fragment, useCallback, useEffect, useMemo, useState } from 'react';
import { Step } from 'react-joyride';
import { useMutation, useQuery } from 'react-query';
import { useLocation, useNavigate } from 'react-router-dom';
import { useLocalStorage, useUpdate, useUpdateEffect } from 'react-use';

import { useBalance } from '../../hooks/useBalance';
import {
  TacticDescriptor,
  TeamInfo,
  convertTeamTactic,
  isConvertionError,
  resolverTeamBalance,
} from '../../utils/tacticUtils';

import { Recommender } from './Recommender';
import Team11Layout from './components/Team11Layout';
import TeamFormationWrapper from './components/TeamFormationWrapper';

import { Button, Loader, Modal, NavBar, TacticPicker } from '@/components';
import { FieldLayout } from '@/components/Layouts/FieldLayout11';
import { OnboardingStepper } from '@/components/OnboardingStepper';
import { DetailsPlayer } from '@/components/Team/';
import { DetailsPlayerSubmit } from '@/components/Team/DetailsPlayer';
import { FormFilterPlayers } from '@/components/Team/FormFilterPlayers';
import { DesktopSidebar, MobileSidebar } from '@/components/Team/Sidebar';
import useAuth from '@/hooks/useAuth';
import useHostbackButton from '@/hooks/useHostbackButton';
import { useIsDesktop } from '@/hooks/useIsDesktop';
import { useGetPlayerPositionByAbbreviation } from '@/hooks/usePlayer';
import { useTeam } from '@/hooks/useTeam11';
import { useTeamStore } from '@/hooks/useTeamStore';
import useToast from '@/hooks/useToast';
import ROUTES from '@/router/routes';
import {
  getInitBuildTeam,
  saveTeamDB,
  saveTeamDraft,
} from '@/services/buildTeam11';
import { TeamActionTypes } from '@/store/team';
import {
  EnumDevice,
  GDTApiErrors,
  Maybe,
  PositionAbbreviationsTypes,
  UserInitialData,
} from '@/types';
import {
  DraftTeam,
  EnumTeamContext,
  PlayerClub,
  RequestEquipoBorrador,
  ResponseArmaEquipoGrabar,
  ResponseGetInitDraftTeam,
  TacticOnField,
  TemplatePlayer,
} from '@/types/team';
import {
  MAX_INPUT_RANGE,
  MIN_INPUT_RANGE,
  TACTICS_ARR,
  TEXTS,
  checkIfPositionsAreCompleted,
  checkTeamHasCaptain,
  getAvailablePositionOnField,
  getPlayerPositionListOnField,
  isFieldEmpty,
  isSelectedPlayerFromList,
  parseJSXElementToPlayerClub,
  showErrorToast,
  SLIDE_IN_OUT_LEFT,
} from '@/utils';

export const Team11 = () => {
  const { userInitialData, setUserInitialData } = useAuth();
  const { isDesktop, isMobile } = useIsDesktop();
  const toast = useToast();
  const updateModule = useUpdate();
  const { state, dispatch } = useTeamStore();
  const { setTeamBalanceByResult } = useBalance();
  const { getPlayersOnField } = useTeam();

  const [localStorageOnboarding] = useLocalStorage<Maybe<string>>(
    `onboarding-${EnumTeamContext.Build11}-${userInitialData?.idUsuarioDT}`,
    null
  );

  const [isPrevTeam, setIsPrevTeam] = useLocalStorage<Maybe<string>>(
    `prevteam-${userInitialData?.idUsuarioDT}`,
    null
  );

  const hasPrevTeam =
    userInitialData &&
    userInitialData.prevTeam &&
    userInitialData.prevTeam.existe;

  const location = useLocation();
  const stateLocation: string = location.state;
  const navigate = useNavigate();

  const [componentIsLoading, setComponentIsLoading] = useState(true);

  const selectedPositionLabel = useGetPlayerPositionByAbbreviation(
    state.selectedPosition,
    false
  );

  useEffect(() => {
    navigate('', { replace: false });
  }, []);

  const {
    data: teamDraftInit,
    isLoading,
    isFetching,
  } = useQuery('getBuildTeam', async () => await getInitBuildTeam(), {
    refetchOnWindowFocus: false,
    keepPreviousData: false,
    onSuccess: (response) => {
      if (response) {
        if (response.estado) {
          setBalanceAndTeam(response, true);
        } else {
          if (response.codError === 214) {
            navigate(ROUTES.myTeam11, {
              replace: true,
            });
            return;
          }
          showErrorToast(response);
          // eslint-disable-next-line no-useless-return
          if (response.codError === 403) return;
          // EQUIPO_YA_REGISTRADO (214)
          // Hago un redirecto a summary si el usuario ya tiene equipo registrado
          // Pero por alguna razon lograr entrar en esta pagina.
        }
      } else {
        toast.show(TEXTS.getTeam);
      }
    },
  });

  const { mutateAsync: submitDraftTeam, isLoading: isLoadingDraftOnSubmit } =
    useMutation(
      async (newTeamDraft: RequestEquipoBorrador) =>
        await saveTeamDraft(newTeamDraft),
      {
        onSuccess: (newTeamSaved) => {
          if (newTeamSaved.estado && newTeamSaved.equipoBorrador) {
            dispatch({
              type: TeamActionTypes.SET_STATE,
              payload: {
                teamDraft: newTeamSaved.equipoBorrador?.jugadores,
                tactic: {
                  id: newTeamSaved.equipoBorrador.idTactica,
                  formation: TACTICS_ARR[newTeamSaved.equipoBorrador.idTactica],
                },
              },
            });
          }
        },
        onError: (error: GDTApiErrors) => {
          toast.show(error.mensaje);
        },
      }
    );

  const { mutateAsync: submitNewTeam, isLoading: isLoadingOnSubmit } =
    useMutation(
      async (newTeamDraft: RequestEquipoBorrador) =>
        await saveTeamDB(newTeamDraft),
      {
        onSuccess: (newTeamSaved) => {
          if (newTeamSaved.estado) {
            dispatch({
              type: TeamActionTypes.RESET,
            });

            navigate(ROUTES.teamConfirm, { replace: true });
          } else {
            toast.show(newTeamSaved.mensaje);
          }
        },
        onError: (error: GDTApiErrors) => {
          toast.show(error.mensaje);
        },
      }
    );

  const displayLoader =
    isLoading ||
    isFetching ||
    isLoadingOnSubmit ||
    isLoadingDraftOnSubmit ||
    componentIsLoading;

  const timeout = isLoadingOnSubmit || isLoadingDraftOnSubmit;
  const showLoader = displayLoader;

  // Effect para validar si el equipo esta completo
  // Tomando en cuenta el capitan + las posiciones completas
  useEffect(() => {
    const jsxPositions = getPlayerPositionListOnField(state.playersOnField);
    const parsedPositions = parseJSXElementToPlayerClub(jsxPositions);
    const teamIsCompleted = checkIfPositionsAreCompleted(parsedPositions);

    dispatch({
      type: TeamActionTypes.SET_STATE,
      payload: {
        teamIsComplete: teamIsCompleted,
      },
    });
  }, [dispatch, state.playersOnField]);

  // use fix not loaded content
  useEffect(() => {
    if (componentIsLoading) {
      setComponentIsLoading(false);
    }
  }, [componentIsLoading]);

  const shouldStartOnboarding = useMemo(() => {
    const startOnBoarding =
      !userInitialData?.tiene_equipo &&
      state.storageOnboardingBuild !== `showed-${userInitialData?.idUsuarioDT}`;

    return startOnBoarding ?? false;
  }, [state]);

  // use Onboarding
  useEffect(() => {
    if (localStorageOnboarding) {
      const jsonStorage = JSON.parse(localStorageOnboarding);
      // valido si muestro el onboarding de mi equipo o armado de equipo
      if (!userInitialData?.tiene_equipo) {
        dispatch({
          type: TeamActionTypes.SET_STATE,
          payload: {
            storageOnboardingBuild: jsonStorage?.onboardingBuild,
          },
        });
      }
    } else {
      // viene de welcome sin equipo y sin storage
      if (!userInitialData?.tiene_equipo && stateLocation !== null) {
        dispatch({
          type: TeamActionTypes.SET_STATE,
          payload: {
            showOnboarding: true,
          },
        });
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [localStorageOnboarding, userInitialData?.tiene_equipo]);

  // use prevteam
  useUpdateEffect(() => {
    const shouldAccessPrevTeam =
      !isPrevTeam && !shouldStartOnboarding && !displayLoader;

    if (shouldAccessPrevTeam && hasPrevTeam) {
      dispatch({
        type: TeamActionTypes.SET_STATE,
        payload: {
          showPrevTeamModal: true,
        },
      });
    }
  }, [displayLoader, shouldStartOnboarding, isPrevTeam, hasPrevTeam]);

  const updatePrevTeamModalValue = (val: boolean) => {
    dispatch({
      type: TeamActionTypes.SET_STATE,
      payload: {
        showPrevTeamModal: val,
        showOnboarding: false,
      },
    });
  };

  const handleDisablePrevTeamModal = () => {
    if (userInitialData?.prevTeam?.existe && !isPrevTeam) {
      setIsPrevTeam('true');
    }
  };

  const handleSubmitNewTeam = async () => {
    const jsxPositions = getPlayerPositionListOnField(state.playersOnField);
    const positions = parseJSXElementToPlayerClub(jsxPositions);
    const teamHasCaptain = checkTeamHasCaptain(positions);

    if (!teamHasCaptain) {
      toast.show(TEXTS.team.pickCaptain);
      return;
    }

    if (state.teamDraft && state.tactic && userInitialData) {
      try {
        await submitNewTeam({
          jugadores: state.teamDraft,
          idTactica: state.tactic.id,
          idUsuario: userInitialData.idUsuarioDT,
        });
        setUserInitialData({
          ...userInitialData,
          tiene_equipo: true,
        } as UserInitialData);
      } catch (error) {
        toast.show(TEXTS.defaultError);
      }
    } else {
      toast.show(TEXTS.defaultError);
    }
  };

  const setBalanceAndTeam = (
    newTeamDraft: ResponseGetInitDraftTeam | ResponseArmaEquipoGrabar,
    isGetDataInit: boolean
  ) => {
    const result = resolverTeamBalance(
      newTeamDraft,
      isGetDataInit,
      state.tournamentPrice
    );

    if (newTeamDraft.equipoBorrador) {
      setTeamBalanceByResult(result);

      return handleSetTeamOnField(
        newTeamDraft.equipoBorrador.idTactica,
        newTeamDraft.equipoBorrador.jugadores
      );
    }

    toast.show(TEXTS.defaultError);
  };

  const handleGetNextPosition = (
    response: ResponseArmaEquipoGrabar | GDTApiErrors,
    playerName: string,
    playerLastName: string
  ) => {
    let updatedTeamOnField: TacticOnField | undefined;
    let teamHasCaptain = false;
    let availablePosition:
      | {
          position: PositionAbbreviationsTypes;
          index: number;
          orden: number | undefined;
        }
      | undefined;

    if (response.estado) {
      const isCodeErrorInResponse =
        'codError' in response && (response.codError as boolean);

      updatedTeamOnField = setBalanceAndTeam(response, false);

      if (updatedTeamOnField) {
        const goalkeepers = [
          updatedTeamOnField.goalkeepers,
          updatedTeamOnField.substitutes[0],
        ] as JSX.Element[];

        const defenders = [
          ...updatedTeamOnField.defenders,
          updatedTeamOnField.substitutes[1],
        ];

        const midfielders = [
          ...updatedTeamOnField.midfielders,
          updatedTeamOnField.substitutes[2],
        ];

        const forwards = [
          ...updatedTeamOnField.forwards,
          updatedTeamOnField.substitutes[3],
        ];

        availablePosition = getAvailablePositionOnField({
          defenders,
          midfielders,
          forwards,
          goalkeepers,
        });

        const teamData = parseJSXElementToPlayerClub([
          ...defenders,
          ...midfielders,
          ...forwards,
          ...goalkeepers,
        ]);

        teamHasCaptain = checkTeamHasCaptain(teamData);
      }

      return {
        ...(!availablePosition && {
          teamHasCaptain,
        }),
        ...(availablePosition && { availablePosition }),
        mensaje: `${playerLastName} ${playerName} ${TEXTS.team.playerAddedOnTeamDraft}`,
        ...(isCodeErrorInResponse && { codError: response.codError }),
      };
    }

    return {
      mensaje: response.mensaje,
      ...(response.codError && { codError: response.codError }),
    };
  };

  // * Guadar jugador en equipo
  const handlePlayerToField = async ({
    isCaptain,
    player,
    willBeDeleted,
  }: DetailsPlayerSubmit) => {
    handleDisablePrevTeamModal();

    const {
      id: selectedPlayerId,
      p: positionPlayerSelected,
      n: nombre,
      a: apellido,
    } = player;

    const positionSelected = positionPlayerSelected - 1;

    // eslint-disable-next-line no-constant-condition
    if (state.tactic && userInitialData?.idUsuarioDT) {
      const teamDraft = cloneDeep(state.teamDraft);

      if (teamDraft) {
        if (willBeDeleted) {
          const newTeam = teamDraft.map((player) => {
            if (player.id === selectedPlayerId) {
              return {
                orden: player.orden,
                id: undefined,
                capitan: false,
              };
            }

            return player;
          });

          const response = await submitDraftTeam({
            jugadores: newTeam,
            idTactica: state.tactic.id,
            idUsuario: userInitialData.idUsuarioDT,
          });

          if (response.estado) {
            setBalanceAndTeam(response, false);
          } else {
            toast.show(response.mensaje);
          }

          dispatch({
            type: TeamActionTypes.SET_STATE,
            payload: {
              selectedPlayerOnList: null,
              selectedPlayerOnBuildTeam: null,
              selectedPosition: null,
              playerDetailsModalOpen: false,
            },
          });
        } else if (isCaptain) {
          if (state.selectedPlayerOnBuildTeam) {
            const newTeam = teamDraft.map((player) => {
              if (player.id === state.selectedPlayerOnBuildTeam?.id) {
                return {
                  ...player,
                  capitan: true,
                };
              }

              return {
                ...player,
                capitan: false,
              };
            });

            const response = await submitDraftTeam({
              jugadores: newTeam,
              idTactica: state.tactic.id,
              idUsuario: userInitialData.idUsuarioDT,
            });

            if (response.estado) {
              setBalanceAndTeam(response, false);

              toast.show(TEXTS.team.captainPicked);
            } else {
              toast.show(response?.mensaje);
            }

            // Limpio seleccion de jugador en cancha
            dispatch({
              type: TeamActionTypes.SET_STATE,
              payload: {
                selectedPlayerOnList: null,
                selectedPlayerOnBuildTeam: null,
                selectedPosition: null,
                playerDetailsModalOpen: false,
              },
            });
          }
        } else {
          const existOnTeam = teamDraft.some(
            (player) => player.id === selectedPlayerId
          );

          if (existOnTeam) {
            toast.show(TEXTS.team.playerAlreadyExists);
            dispatch({
              type: TeamActionTypes.SET_STATE,
              payload: {
                playerDetailsModalOpen: false,
              },
            });
            return;
          }

          const isSelectedFromPosition = state.selectedPlayerOnBuildTeam;
          const isSelectedFromList =
            state.selectedPlayerOnList && !state.selectedPlayerOnBuildTeam;

          // Guardar jugador basado en la posicion seleccionada
          if (isSelectedFromPosition) {
            const newTeam = teamDraft.map((player) => {
              if (
                state.selectedPlayerOnBuildTeam &&
                'orden' in state.selectedPlayerOnBuildTeam &&
                player.orden === state.selectedPlayerOnBuildTeam?.orden
              ) {
                if (player.id) {
                  toast.show(TEXTS.team.noVacant);
                  return player;
                }

                return {
                  ...player,
                  id: selectedPlayerId,
                };
              }
              return player;
            });

            const response = await submitDraftTeam({
              jugadores: newTeam,
              idTactica: state.tactic.id,
              idUsuario: userInitialData.idUsuarioDT,
            });

            const nextPositionResult = handleGetNextPosition(
              response,
              nombre,
              apellido
            );

            // Mensaje de success o error
            toast.show(nextPositionResult.mensaje);

            const haveNextPosition = 'availablePosition' in nextPositionResult;

            if (haveNextPosition) {
              const nextPosition = teamDraft.find((team: PlayerClub) => {
                return (
                  team.orden === nextPositionResult.availablePosition?.orden
                );
              });

              if (nextPosition) {
                handleSelectPlayer(nextPosition);

                dispatch({
                  type: TeamActionTypes.SET_STATE,
                  payload: {
                    selectedPosition:
                      nextPositionResult.availablePosition?.position,
                    playerDetailsModalOpen: false,
                  },
                });
              }
            } else {
              const teamHasCaptain =
                'teamHasCaptain' in nextPositionResult
                  ? nextPositionResult.teamHasCaptain
                  : false;

              const teamHasErrors = 'codError' in nextPositionResult;

              const noCaptainAndNoErrors = !teamHasCaptain && !teamHasErrors;
              const hasCaptainAndNoErrors = teamHasCaptain && !teamHasErrors;

              if (noCaptainAndNoErrors) {
                toast.show(TEXTS.team.pickCaptain);
              }

              dispatch({
                type: TeamActionTypes.SET_STATE,
                payload: {
                  ...((noCaptainAndNoErrors || hasCaptainAndNoErrors) && {
                    selectedPlayerOnList: null,
                    selectedPlayerOnBuildTeam: null,
                    selectedPosition: null,
                  }),
                  playerDetailsModalOpen: false,
                },
              });
            }
          }

          if (isSelectedFromList) {
            const closePlayerDetails = () => {
              dispatch({
                type: TeamActionTypes.SET_STATE,
                payload: {
                  selectedPlayerOnList: null,
                  selectedPlayerOnBuildTeam: null,
                  playerDetailsModalOpen: false,
                },
              });
            };

            const positionIsEmptyByIndex = (counterPosition: number) => {
              if (teamDraft[counterPosition].id === undefined) {
                return true;
              }

              return false;
            };

            const addPlayerOnField = (counterPosition: number) => {
              teamDraft[counterPosition] = {
                ...teamDraft[counterPosition],
                id: selectedPlayerId,
              };
            };

            const isFullTacticLine = (start: number, end: number) => {
              const newTeamSliced = teamDraft.slice(0);
              const tacticFormation = newTeamSliced.splice(
                start,
                end
              ) as PlayerClub[];
              return tacticFormation.every((player) => player.id !== undefined);
            };

            // Sumo arquero titular y suplente separado del resto de jugadores
            if (positionSelected === 0) {
              if (positionIsEmptyByIndex(0)) {
                addPlayerOnField(0);
              } else if (positionIsEmptyByIndex(11)) {
                addPlayerOnField(11);
              } else {
                toast.show(TEXTS.team.noVacant);
                closePlayerDetails();
                return;
              }

              const response = await submitDraftTeam({
                jugadores: teamDraft,
                idTactica: state.tactic.id,
                idUsuario: userInitialData.idUsuarioDT,
              });

              if (response.estado) {
                setBalanceAndTeam(response, false);
                toast.show(
                  `${apellido} ${nombre} ${TEXTS.team.playerAddedOnTeamDraft}`
                );

                closePlayerDetails();
              } else {
                toast.show(response.mensaje);
              }
            } else {
              let positionLineIsFull = false;
              // Encontrar en que orden se va a agregar al usuario basado en la tactica;
              const tacticArray: number[] = TACTICS_ARR[state.tactic.id];

              // Modificar el objeto teamDraft directamente para agregar los jugadores
              // en la posicion correcta
              let position = 0;
              list: for (let i = 0; i <= tacticArray.length; i++) {
                const positionOnField: number = tacticArray[i];
                for (let j = 0; j < positionOnField; j++) {
                  const counterPosition = ++position;
                  if (
                    tacticArray[0] === positionOnField &&
                    i === 0 &&
                    positionSelected === 1
                  ) {
                    // Sumar jugador defensas
                    if (positionIsEmptyByIndex(counterPosition)) {
                      addPlayerOnField(counterPosition);
                      break list;
                    } else if (isFullTacticLine(1, positionOnField)) {
                      if (positionIsEmptyByIndex(12)) {
                        addPlayerOnField(12);
                        break list;
                      } else {
                        positionLineIsFull = true;
                        break list;
                      }
                    }
                  } else if (
                    tacticArray[1] === positionOnField &&
                    i === 1 &&
                    positionSelected === 2
                  ) {
                    // Sumar jugadores volantes
                    if (positionIsEmptyByIndex(counterPosition)) {
                      addPlayerOnField(counterPosition);
                      break list;
                    } else if (
                      isFullTacticLine(tacticArray[0] + 1, positionOnField)
                    ) {
                      if (positionIsEmptyByIndex(13)) {
                        addPlayerOnField(13);
                        break list;
                      } else {
                        positionLineIsFull = true;
                        break list;
                      }
                    }
                  } else if (
                    tacticArray[2] === positionOnField &&
                    i === 2 &&
                    positionSelected === 3
                  ) {
                    // Sumar jugador titular delanteros
                    if (positionIsEmptyByIndex(counterPosition)) {
                      addPlayerOnField(counterPosition);
                      break list;
                    } else if (
                      isFullTacticLine(
                        tacticArray[0] + tacticArray[1] + 1,
                        positionOnField
                      )
                    ) {
                      if (positionIsEmptyByIndex(14)) {
                        addPlayerOnField(14);
                        break list;
                      } else {
                        positionLineIsFull = true;
                        break list;
                      }
                    }
                  }
                }
              }

              const response = await submitDraftTeam({
                jugadores: teamDraft,
                idTactica: state.tactic.id,
                idUsuario: userInitialData.idUsuarioDT,
              });

              if (response.estado) {
                if (response.equipoBorrador) {
                  setBalanceAndTeam(response, false);

                  const teamHasCaptain = checkTeamHasCaptain(
                    response.equipoBorrador.jugadores
                  );

                  const teamIsCompleted = checkIfPositionsAreCompleted(
                    response.equipoBorrador.jugadores
                  );

                  if (!positionLineIsFull) {
                    toast.show(
                      `${apellido} ${nombre} ${TEXTS.team.playerAddedOnTeamDraft}`
                    );

                    if (!teamHasCaptain && teamIsCompleted) {
                      toast.show(TEXTS.team.pickCaptain);
                    }
                  } else {
                    toast.show(TEXTS.team.noVacant);
                  }
                }
              } else {
                // Entra aca si hay un error al agregar el jugador
                // si el equipo cuenta ya con 2 judaores del mismo club en cancha, ejemplo Codigo 208
                toast.show(response.mensaje ?? TEXTS.defaultError);
              }

              closePlayerDetails();
            }
          }
        }
      }
    } else {
      toast.show(TEXTS.defaultError);
    }
  };

  const handleSelectPlayer = (player: PlayerClub | TemplatePlayer) => {
    navigate('', { replace: false });
    if (isSelectedPlayerFromList(player)) {
      dispatch({
        type: TeamActionTypes.SET_STATE,
        payload: {
          selectedPlayerOnList: player,
          playerDetailsModalOpen: true,
        },
      });
    } else {
      const hasPlayer = Boolean(player.id);
      dispatch({
        type: TeamActionTypes.SET_STATE,
        payload: {
          selectedPlayerOnBuildTeam: player,
          ...(!hasPlayer && { selectedPosition: player.posicion?.nombreCorto }),
          ...(hasPlayer && { playerDetailsModalOpen: true }),
        },
      });
    }
  };

  const handleResetHeaderInfo = () => {
    navigate('', { replace: false });
    dispatch({
      type: TeamActionTypes.SET_STATE,
      payload: {
        showFiltersPlayersList: !state.showFiltersPlayersList,
      },
    });
  };

  const handleBackButton = useCallback(() => {
    dispatch({
      type: TeamActionTypes.SET_STATE,
      payload: {
        ...(!state.showFiltersPlayersList
          ? {
              selectedPlayerOnBuildTeam: null,
              showModalRecommender: false,
            }
          : { showFiltersPlayersList: false }),
      },
    });
  }, [state.showFiltersPlayersList]);

  useHostbackButton(handleBackButton);

  const handleSubmitNewTactic = (tacticNumber: number) => {
    if (state.teamDraft && state.tactic) {
      const sourceTeam: TeamInfo = {
        players: state.teamDraft as PlayerClub[],
        tactic: TacticDescriptor.byId(state.tactic.id),
      };

      const convertedTeam = convertTeamTactic(
        sourceTeam,
        TacticDescriptor.byId(tacticNumber)
      );

      if (isConvertionError(convertedTeam)) {
        navigate(`${ROUTES.changeTactic}?id=${tacticNumber}`, {
          replace: true,
        });
      } else {
        // console.log(convertedTeam.players);
        // set team tactic without remove players
        saveDraftTeamAndBalance(tacticNumber, convertedTeam.players);
      }
    }
  };

  const saveDraftTeamAndBalance = async (
    newTactic: number,
    newTeam: PlayerClub[]
  ) => {
    if (userInitialData) {
      const response = await submitDraftTeam({
        jugadores: newTeam,
        idTactica: newTactic,
        idUsuario: userInitialData.idUsuarioDT,
      });

      if (response.estado) {
        setBalanceAndTeam(response, false);
      } else {
        toast.show(response?.mensaje);
      }
    }
  };

  // Esta funcion se encarga de dibujar los jugadores en la cancha
  const handleSetTeamOnField = (idTactic: number, team: PlayerClub[]) => {
    const players = getPlayersOnField({
      team,
      idTactic,
      handleSelectPlayer,
      context: EnumTeamContext.Build11,
    });

    const data = {
      type: TeamActionTypes.SET_STATE,
      payload: {
        teamDraft: team,
        tactic: { id: idTactic, formation: TACTICS_ARR[idTactic] },
        playersOnField: {
          goalkeepers: players.goalkeepers,
          defenders: players.defenders,
          midfielders: players.midfielders,
          forwards: players.forwards,
          substitutes: players.substitutes,
        },
      },
    };

    dispatch(data);

    return data.payload.playersOnField;
  };

  const pageTitles = useMemo(() => {
    return {
      title: 'Armá tu equipo',
      subtitle: userInitialData?.nombre_equipo ?? '',
    };
  }, [userInitialData]);

  const handleUsePrevTeam = async () => {
    if (
      userInitialData?.prevTeam &&
      userInitialData.prevTeam.estado &&
      userInitialData.prevTeam.existe
    ) {
      const teamBudget = userInitialData.prevTeam.equipoAnterior?.importeTotal;
      const tacticId = userInitialData.prevTeam.equipoAnterior?.idTactica;
      const prevTeamDraft = userInitialData.prevTeam.equipoAnterior?.jugadores;
      const gameBudget = state.balance;

      if (tacticId && prevTeamDraft && teamBudget && gameBudget) {
        const total = gameBudget - teamBudget;

        if (total < 0) {
          let playerList: PlayerClub[] = [];
          let bugdetPerPlayer = 0;

          for (const index in prevTeamDraft) {
            const player = prevTeamDraft[index];

            const playerCost = player.cotizacion ?? 0;

            bugdetPerPlayer = bugdetPerPlayer + playerCost;

            if (bugdetPerPlayer <= gameBudget) {
              playerList = [...playerList, player];
            }
          }

          const newTeamDraft = prevTeamDraft.map((player) => {
            if (playerList.some((p) => p.id === player.id)) {
              return player;
            }

            return {
              orden: player.orden,
              titular: true,
              capitan: false,
            };
          });

          const response = await submitDraftTeam({
            jugadores: newTeamDraft,
            idTactica: tacticId,
            idUsuario: userInitialData.idUsuarioDT,
          });

          if (response.estado) {
            setBalanceAndTeam(response, false);
            handleDisablePrevTeamModal();

            toast.show(TEXTS.prevTeam.noBudge);
          } else {
            toast.show(response.mensaje);
          }
        } else {
          const response = await submitDraftTeam({
            jugadores: prevTeamDraft,
            idTactica: tacticId,
            idUsuario: userInitialData.idUsuarioDT,
          });

          if (response.estado) {
            setBalanceAndTeam(response, false);
            handleDisablePrevTeamModal();

            toast.show(TEXTS.prevTeam.success);
          } else {
            toast.show(response.mensaje);
          }
        }
      } else {
        toast.show(TEXTS.defaultError);
      }
    } else {
      toast.show(TEXTS.defaultError);
    }
  };

  const onSubmitRecommender = (draftTeam: DraftTeam) => {
    teamDraftInit &&
      teamDraftInit.estado &&
      setBalanceAndTeam(
        {
          tieneEquipoBorrador: teamDraftInit.tieneEquipoBorrador,
          nombreEquipo: teamDraftInit.nombreEquipo,
          estado: true,
          presupuestoTorneo: teamDraftInit.presupuestoTorneo,
          equipoBorrador: draftTeam,
        },
        false
      );
    dispatch({
      type: TeamActionTypes.SET_STATE,
      payload: { showModalRecommender: false },
    });
  };

  const teamFormationActions = (
    <div className="space-x-4">
      <Modal
        bottomSheetClassName="px-[1rem] pb-12 pt-0"
        className="px-[35px] py-[1.75rem]"
        render={({ closeModal }) => (
          <TacticPicker
            fieldSelectedTactic={state.tactic?.id ?? 1}
            onSubmit={(tacticId) => {
              handleSubmitNewTactic(tacticId);
              closeModal();
            }}
          />
        )}
        size="2xs"
        trigger={({ openModal }) => (
          <div className="relative inline-block">
            <span className="refButtonSelecTactic absolute left-0 h-28 w-full top-1/2 -translate-y-1/2" />
            <Button
              className="px-[24px]"
              type="button"
              variant="secondary"
              onClick={openModal}
            >
              {state?.tactic?.formation?.toString().replaceAll(',', '-')}
            </Button>
          </div>
        )}
        variant="default"
      />

      {isDesktop ? (
        <div className="inline-block relative">
          <span className="refButtonRecommender absolute left-0 h-28 w-full top-1/2 -translate-y-1/2" />
          <Button
            type="button"
            variant="secondary"
            onClick={() => {
              navigate('', { replace: false });
              dispatch({
                type: TeamActionTypes.SET_STATE,
                payload: { showModalRecommender: true },
              });
            }}
          >
            Recomendador
          </Button>
        </div>
      ) : (
        <div className="inline-block relative">
          <span className="refButtonRecommender absolute left-0 h-28 w-full top-1/2 -translate-y-1/2" />
          <Button
            type="button"
            variant="secondary"
            onClick={() => {
              navigate(ROUTES.recommender, { replace: true });
            }}
          >
            Recomendador
          </Button>
        </div>
      )}

      {isDesktop && (
        <Button
          disabled={!state.teamIsComplete}
          type="button"
          variant="primary"
          onClick={() => {
            if (state.teamIsComplete) {
              handleSubmitNewTeam();
            }
          }}
        >
          Confirmar equipo
        </Button>
      )}
    </div>
  );

  const textStep3Build = isMobile
    ? 'Agregá a los jugadores de tu equipo haciendo click en las camisetas.'
    : 'Agregá a los jugadores de tu equipo haciendo click en las camisetas o desde el listado derecho.';

  const contentStepsOnboardingBuild: Step[] = [
    {
      target: '.refButtonSelecTactic',
      title: 'CAMBIO DE TÁCTICA',
      content:
        'Podés elegir y cambiar tu táctica de juego en cualquier momento.',

      placement: 'top',
      disableBeacon: true,
    },
    {
      target: '.refButtonRecommender',
      title: 'RECOMENDADOR',
      content:
        'Si no conocés mucho de fútbol o necesitás asistencia, el recomendador te puede ayudar con la selección de tus jugadores.',
      placement: 'top',
    },
    {
      target: '#refPlayerField-4',
      title: 'JUGADORES',
      content: textStep3Build,
      placement: 'bottom',
    },
  ];

  const openPrevTeamModal = useMemo(() => {
    const fieldEmpty = isFieldEmpty(state.playersOnField);
    const isPrevItemInLocalStorage = Boolean(isPrevTeam);

    return (
      Boolean(state.showPrevTeamModal) &&
      !displayLoader &&
      fieldEmpty &&
      !isPrevItemInLocalStorage
    );
  }, [
    displayLoader,
    isPrevTeam,
    state.playersOnField,
    state.showPrevTeamModal,
  ]);

  const isMounted = isDesktop && !componentIsLoading;

  return (
    <>
      <Team11Layout subtitle={pageTitles.subtitle} title={pageTitles.title}>
        <>
          {<Loader isVisible={showLoader} timeout={timeout} />}

          {shouldStartOnboarding && (
            <OnboardingStepper
              contentSteps={contentStepsOnboardingBuild}
              context={EnumTeamContext.Build11}
              userId={userInitialData?.idUsuarioDT}
              onClose={() => {
                if (hasPrevTeam) {
                  updatePrevTeamModalValue(true);
                } else {
                  updatePrevTeamModalValue(false);
                }
              }}
            />
          )}

          <FieldLayout.Main
            context={EnumTeamContext.Build11}
            onConfirmMobile={
              <Button
                className="w-[20.5rem] my-6"
                disabled={!state.teamIsComplete}
                type="button"
                variant="primary"
                onClick={() => {
                  if (state.teamIsComplete) {
                    handleSubmitNewTeam();
                  }
                }}
              >
                Confirmar equipo
              </Button>
            }
          >
            {toast.scopeToastContainer}
            {isMobile && (
              <TeamFormationWrapper
                content={teamFormationActions}
                variant={EnumDevice.Mobile}
              />
            )}
            <FieldLayout.Inner>
              <FieldLayout.Field
                backDropOnClick={() => {
                  dispatch({
                    type: TeamActionTypes.SET_STATE,
                    payload: {
                      selectedPlayerOnList: null,
                      selectedPlayerOnBuildTeam: null,
                      selectedPosition: null,
                      showFiltersPlayersList: false,
                      ...state.filtersApplied,
                    },
                  });
                }}
                backDropOpen={
                  Boolean(state.selectedPlayerOnBuildTeam) ||
                  Boolean(state.showFiltersPlayersList)
                }
                context={EnumTeamContext.Build11}
                defenders={state.playersOnField?.defenders}
                floatingCard={
                  <TeamFormationWrapper
                    content={teamFormationActions}
                    teamName={userInitialData?.nombre_equipo ?? ''}
                    variant={EnumDevice.Desktop}
                  />
                }
                forwards={state.playersOnField?.forwards}
                goalkeeper={state.playersOnField?.goalkeepers}
                isMounted={isMounted}
                midfielders={state.playersOnField?.midfielders}
                selectedPositionOrden={
                  state.selectedPlayerOnBuildTeam &&
                  'orden' in state.selectedPlayerOnBuildTeam
                    ? state.selectedPlayerOnBuildTeam.orden
                    : undefined
                }
                subtitutes={state.playersOnField?.substitutes}
                tacticId={state.tactic?.id ?? 1}
              />
            </FieldLayout.Inner>
          </FieldLayout.Main>
          {isMounted && (
            <FieldLayout.Sidebar>
              <DesktopSidebar
                context={EnumTeamContext.Build11}
                handleSelectPlayerOnList={handleSelectPlayer}
                onClick={handleResetHeaderInfo}
              />
            </FieldLayout.Sidebar>
          )}
        </>
      </Team11Layout>

      {/* Modal para equipo pasado */}
      <Modal
        bottomSheetClassName="pt-10 pb-12"
        className="px-10"
        controlledOnClose={() => updatePrevTeamModalValue(false)}
        isControlledOpen={openPrevTeamModal}
        render={() => {
          return (
            <Fragment>
              <div className="px-10 lg:px-0">
                <h1 className="text-base text-black font-semibold text-center">
                  ¿Querés usar tu equipo de la edición pasada?
                </h1>
              </div>
              <div className="px-5 lg:px-10 mt-[1.19rem]">
                <p className="text-sm font-normal text-[#332F2D] text-center">
                  Se agregarán los futbolistas que participen actualmente del
                  torneo argentino.
                </p>
              </div>
              <div className="flex items-center mt-[2rem] gap-x-[0.5rem]">
                <div className="flex-1">
                  <Button
                    className="py-[0.825rem] w-full"
                    type="button"
                    variant="secondary"
                    onClick={() => {
                      updatePrevTeamModalValue(false);
                      updateModule();
                    }}
                  >
                    {isDesktop ? 'Crear equipo nuevo' : 'Crear nuevo'}
                  </Button>
                </div>
                <div className="flex-1">
                  <Button
                    className="px-1 lg:px-[18px] py-[0.825rem] w-full"
                    type="button"
                    variant="primary"
                    onClick={async () => {
                      await handleUsePrevTeam();
                      updateModule();
                    }}
                  >
                    Usar equipo pasado
                  </Button>
                </div>
              </div>
            </Fragment>
          );
        }}
        showCloseButton={isMobile ? false : undefined}
        size="xs"
        variant="controlled"
      />

      {/* Modal para detalle del jugador */}
      <Modal
        bottomSheetClassName="px-[16px]"
        className="px-[1.06rem] lg:px-11 py-10"
        controlledOnClose={() => {
          const isUsedPosition = Boolean(state.selectedPlayerOnBuildTeam?.id);

          if (displayLoader) {
            return;
          }

          if (isDesktop) {
            dispatch({
              type: TeamActionTypes.SET_STATE,
              payload: {
                ...(isUsedPosition
                  ? {
                      selectedPlayerOnList: null,
                      selectedPlayerOnBuildTeam: null,
                      selectedPosition: null,
                    }
                  : {
                      selectedPlayerOnBuildTeam: null,
                    }),
                playerDetailsModalOpen: false,
              },
            });
          } else {
            dispatch({
              type: TeamActionTypes.SET_STATE,
              payload: {
                ...(isUsedPosition && {
                  selectedPlayerOnList: null,
                  selectedPlayerOnBuildTeam: null,
                  selectedPosition: null,
                }),
                playerDetailsModalOpen: false,
              },
            });
          }
        }}
        isControlledOpen={Boolean(state.playerDetailsModalOpen)}
        render={() => {
          if (state.selectedPlayerOnList || state.selectedPlayerOnBuildTeam) {
            return (
              <DetailsPlayer
                isLoading={isLoadingDraftOnSubmit}
                playerId={
                  state.selectedPlayerOnBuildTeam?.id ??
                  state.selectedPlayerOnList?.id
                }
                playersOnField={state.playersOnField}
                selectedPlayerOnField={state.selectedPlayerOnBuildTeam}
                selectedPlayerOnList={state.selectedPlayerOnList}
                variant={state.selectedPlayerOnBuildTeam?.id ? 'delete' : 'add'}
                onSubmitPlayer={handlePlayerToField}
              />
            );
          }

          return null;
        }}
        size="xs"
        variant="controlled"
      />

      {/* Modal Recomendador */}
      <Modal
        className="px-0 pb-8 pt-2"
        controlledOnClose={() =>
          dispatch({
            type: TeamActionTypes.SET_STATE,
            payload: { showModalRecommender: false },
          })
        }
        isControlledOpen={Boolean(state.showModalRecommender)}
        render={() => {
          return <Recommender onSubmitRecommender={onSubmitRecommender} />;
        }}
        size="2xs"
        variant="controlled"
      />

      {/* SlideOver para seleccion de jugadores */}
      {
        <AnimatePresence>
          {Boolean(
            state.selectedPlayerOnBuildTeam &&
              !state.selectedPlayerOnBuildTeam?.id
          ) &&
            isMobile && (
              <motion.nav
                animate="show"
                className="fixed top-0 w-full z-50"
                initial="hide"
                variants={SLIDE_IN_OUT_LEFT}
              >
                <MobileSidebar
                  backAction={() => {
                    dispatch({
                      type: TeamActionTypes.SET_STATE,
                      payload: {
                        selectedPlayerOnList: null,
                        selectedPlayerOnBuildTeam: null,
                        selectedPosition: null,
                        filtersApplied: {
                          intoBudget: false,
                          orderBy: null,
                          orderClub: null,
                          valuesRange: [MIN_INPUT_RANGE, MAX_INPUT_RANGE],
                        },
                      },
                    });
                  }}
                  context={EnumTeamContext.Build11}
                  handleSelectPlayerOnList={handleSelectPlayer}
                  title={`Seleccionar ${selectedPositionLabel}`}
                  onClick={handleResetHeaderInfo}
                />
              </motion.nav>
            )}
        </AnimatePresence>
      }

      {/* SlideOver para filtros */}
      <AnimatePresence>
        {state.showFiltersPlayersList && isMobile && (
          <motion.nav
            animate="show"
            className="fixed top-0 w-full z-50"
            initial="hide"
            variants={SLIDE_IN_OUT_LEFT}
          >
            <NavBar
              mobile={{
                rightContent: {
                  customRightAction: () => {
                    dispatch({
                      type: TeamActionTypes.SET_STATE,
                      payload: {
                        showFiltersPlayersList: false,
                        ...state.filtersApplied,
                      },
                    });
                  },
                },
                centerContent: {
                  title: `Filtros`,
                },
              }}
            >
              <FormFilterPlayers context={EnumTeamContext.Build11} />
            </NavBar>
          </motion.nav>
        )}
      </AnimatePresence>
    </>
  );
};
